import {createSlice} from "@reduxjs/toolkit";
import {IInitialStateStudents} from "../types";
import {GetStudents} from "./thunk";

const initialState: IInitialStateStudents = {
    students: [],
    isLoadingStudents: true
}


const studentsSlice = createSlice({
    name: "students",
    initialState,
    reducers: {
        setStudents: (state, action) => {
            state.students = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetStudents.pending, (state) => {
                state.isLoadingStudents = true;
            })
            .addCase(GetStudents.fulfilled,(state) => {
                    state.isLoadingStudents = false;
                }
            )
            .addCase(GetStudents.rejected, (state) => {
                state.isLoadingStudents = false;
            })
    }
})

export const {
    setStudents
} = studentsSlice.actions


export default studentsSlice